// extracted by mini-css-extract-plugin
module.exports = {"container":"FileDropZone__container__MB2PA","fader":"FileDropZone__fader__VPFXY","dragover":"FileDropZone__dragover__G8C-G","faderContent":"FileDropZone__faderContent__7Lwec"};